class DetailedJobItemController {
  constructor(ResultsService) {
    this.ResultsService = ResultsService;
  }
  getInterest() {
    return this.ResultsService.calculateInterest(this.job.interests);
  }
  getSkillCount() {
    return this.ResultsService.getSkillCount(this.job.skills);
  }
  getEducation() {
    return this.ResultsService.calculateEducationMatch(this.job.education);
  }
}

DetailedJobItemController.$inject = ['ResultsService'];

export default DetailedJobItemController;



// WEBPACK FOOTER //
// ./src/components/detailedJobItem/detailedJobItem.controller.js